<nida-web-site-wrapper headline="User management">
  <nida-web-card [disableHeadline]="true">
    <nida-web-user-table [tableData]="tableData" [currentUser]="currentUser" [groups]="groups"> </nida-web-user-table>
  </nida-web-card>
</nida-web-site-wrapper>
